module.exports = __webpack_public_path__ + "static/media/206-header2.2f69cfdb.jpg";